var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("agent-status-settings", {
    attrs: {
      "status-options": _vm.statusOptions,
      "default-status-key": _vm.defaultStatusKey,
      "target-key": _vm.targetKey,
      "show-sidebar": _vm.showSidebar,
      "is-initializing": _vm.isInitializing,
      "is-updating": _vm.isUpdating,
    },
    on: {
      "items-order-change": _vm.onItemsOrderChange,
      "open-create-sidebar": _vm.onOpenCreateSidebar,
      "open-update-sidebar": _vm.onOpenUpdateSidebar,
      "default-key-change": _vm.onDefaultKeyChange,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }